module.exports = __webpack_public_path__ + "static/media/bank-transfer.79f7f248.svg";